import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import * as keys from "../enums/QueryKeys";
import { returnSubmit } from "../enums/queryFunction/Submit";
import { SnackbarContext } from "../contexts/Snackbar";
import { useGetUserId } from "./useUser";
import { BOOKING } from "../enums/ApiPaths";
import { ToggleDrawerContext } from "../contexts/ToggleDrawer";
import { snackbarSeverity } from "./useSnackbar";

export default function useSubmitBookingModal(petId) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const queryClient = useQueryClient();
  const loggedInUserId = useGetUserId();
  const url = BOOKING + loggedInUserId;

  const submitCallback = async (obj) => {
    setLoading(true);
    mutate(obj);
  };

  function updateData(newData) {
    queryClient.setQueryData([keys.APPOINTMENTS], (oldData) => {
      if (!oldData) {
        return [...[], newData];
      }
      const returnArry = [...oldData, newData];
      return returnArry;
    });
    queryClient.invalidateQueries([keys.PENDING_APPOINTMENTS + petId]);
  }

  const { mutate } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      if (response?.data) {
        updateData(response?.data);
      }
      setIsOpen(false);
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (e) => {
      handleSnackbar(e, snackbarSeverity.ERROR);
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
